// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"bb2c83d3","140":"e2acda4b","154":"4ab3304a","207":"dec3f418","544":"a6985890","662":"7246167f","743":"0e070768","927":"f8d59443"}[chunkId] + ".chunk.js";
};